import { ArticleParagraph1, ArticleParagraph2 } from '@cian/ui-kit/typography';
import * as React from 'react';

import { useIsFiltersRedesign } from '../../../context';

interface IChipTextProps {
  children: React.ReactNode;
}

/**
 * Подпись чипса: в редизайне текст мельче (14/20), в текущем дизайне остаётся 16/24.
 */
export const ChipText = ({ children }: IChipTextProps) => {
  const isRedesign = useIsFiltersRedesign();

  return isRedesign ? (
    <ArticleParagraph2>{children}</ArticleParagraph2>
  ) : (
    <ArticleParagraph1>{children}</ArticleParagraph1>
  );
};
